import { makeStyles, Theme } from '@material-ui/core'

import { FullScreenStepperHeaderProps } from './FullScreenStepperHeaderProps'

export const useFullScreenStepperHeaderStyles = makeStyles<Theme, FullScreenStepperHeaderProps>(({ spacing }) => ({
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  root: {
    alignItems: 'center',
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: spacing(1.5, 0),
    position: 'sticky',
    top: 0,
    zIndex: 3,
  },
}))
